import { types as actionTypes } from './waiverWorkItemResolutionsActions';
import { Action } from '../../../types';
import { Resolution } from '../../../../types/waiverWorkItem';

export interface WaiverWorkItemResolutionsState {
  loading: boolean;
  entities?: Resolution[];
  error?: string;
}

const initialState: WaiverWorkItemResolutionsState = {
  loading: false,
};

export default function reducer(
  state: WaiverWorkItemResolutionsState = initialState,
  action: Action<Resolution[]>,
): WaiverWorkItemResolutionsState {
  switch (action.type) {
    case actionTypes.LOAD:
      return {
        loading: true,
      };
    case actionTypes.LOAD_SUCCESS:
      return {
        loading: false,
        entities: action.response,
      };
    case actionTypes.LOAD_FAILURE:
      return {
        loading: false,
        error: action.error ? action.error.message : undefined,
      };
    default:
      return state;
  }
}
